export const LOGBOOK = '/notifications';
export const WHO_AM_I = ``;
export const GLOBAL_SETTINGS = `/global-settings`;
export const SETTINGS = `/settings`;
export const END_OF_DAY = `/end-of-day`;
